export var getLink = function getLink(href, originUrl) {
  var targetLink = href;
  if (href) {
    if (href.includes('http')) {
      targetLink = href;
    } else {
      targetLink = originUrl + href;
    }
  }
  return targetLink;
};
export var splitArray = function splitArray(children) {
  var splitArrayA = [];
  var splitArrayB = [];
  for (var i = 0; i < children.length; i++) {
    var item = children[i];
    // if ((i + 1) % 2 === 0) {
    if (item.type === 'right') {
      splitArrayB.push(item);
    } else {
      splitArrayA.push(item);
    }
  }
  return [splitArrayA, splitArrayB];
};

// copy from modular
// try refactor with lodash
export var throttle = function throttle(func, delay) {
  var lastCallTime = 0;
  return function () {
    var now = Date.now();
    if (now - lastCallTime >= delay) {
      func.apply(null, arguments);
      lastCallTime = now;
    }
  };
};